let imgSrc = [
  'https://cdn.shopify.com/s/files/1/0560/3321/4511/t/2/assets/ARNO_DECLERCQ_825x825.webp?v=1655905477',
  'https://cdn.shopify.com/s/files/1/0560/3321/4511/t/2/assets/PORTRAIT_-_FREDERIC_IMBERT.jpg?v=1655373383',
  'https://cdn.shopify.com/s/files/1/0560/3321/4511/t/2/assets/PORTRAIT_-_GUILLAUME_DUNAN.jpeg?v=1655373173',
  'https://cdn.shopify.com/s/files/1/0560/3321/4511/t/2/assets/Marina_Declarey_-_Portrait_1.png?v=1655905495',
  'https://cdn.shopify.com/s/files/1/0560/3321/4511/t/2/assets/PORTRAIT_-_MAXIME_BOUTILLIER.jpeg?v=1655373191',
  'https://cdn.shopify.com/s/files/1/0560/3321/4511/t/2/assets/PORTRAIT_-_Arthur_Vallin.jpeg?v=1655373155',
  'https://cdn.shopify.com/s/files/1/0560/3321/4511/t/2/assets/PORTRAIT_-_AXEL_CHAY_MARS_210707.jpeg?v=1655373395',
  'https://cdn.shopify.com/s/files/1/0560/3321/4511/t/2/assets/PORTRAIT_-_NOMA.jpeg?v=1655373200']
let imgAlt = [
  'Arno Declercq',
  'Frédéric Imbert',
  'Guillaume Dunan',
  'Marina Declarey',
  'Maxime Boutillier',
  'Arthur Vallin',
  'Axel Chay',
  'Noma Éditions',
]
// loop 
var comptepicture = 0
  
// initialisation image
let img = document.querySelector('.imgs-designeur img')
img.src = imgSrc[0]
img.alt = imgAlt[0]  
let links = document.querySelectorAll('.navigation-custom li a')
for (let i = 0; i < links.length; i++) {
  links[i].addEventListener('mouseover', (e) => {
    let img = document.querySelector('.imgs-designeur img')
    img.classList.add('transitioning-src')
    setTimeout(() => {
      img.src = imgSrc[i]
      img.alt = imgAlt[i]
      img.classList.add('parallax-slider')
      img.classList.remove('transitioning-src')
      comptepicture = (i + 1) % 8
    }, 200)
  })
}
           
           